import styled from '@emotion/styled'

import ProgressBar from './ProgressBar'

// Fill the nearest positioned page container so the spinner centers within it.
// Allow interactions with the page beneath the overlay.
const PageLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

/** Provides the positioning context and minimum height required by `PageLoading`. */
export const PageLoadingContainer = styled.div`
  position: relative;
  min-height: 60vh;
`

/** Full-page loader; use `Loading` for a card, modal, or section. */
const PageLoading = () => (
  <PageLoadingOverlay>
    <ProgressBar type='circular' mode='indeterminate' multicolor />
  </PageLoadingOverlay>
)

export default PageLoading
